import api from "@/services/api"
import { useQuery } from "@tanstack/vue-query"
import { BASE_ORGANIZATIONS_QUERY_KEY } from "../queryKeys"

export type RetrieveOrganizationConfigResponse = {
  businessFundingEnabled: boolean
  websocketServiceEnabled: boolean
  smsServiceEnabled: boolean
  organizationName: string
  appName: string
}

export const retrieveSelfOrg = async () => {
  const { body } =
    await api.get<RetrieveOrganizationConfigResponse>(
      "/get-organization-config/"
    )
  return body
}

export const useOrganizationConfig = () => {
  const { accessToken } = useAuth()

  const { data } = useQuery({
    queryKey: [BASE_ORGANIZATIONS_QUERY_KEY],
    queryFn: retrieveSelfOrg,
    enabled: computed(() => !!accessToken.value),
    refetchInterval: 60 * 60 * 1000, // Refetch org config once an hour
  })

  return { organizationConfig: data }
}
